/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BrokerPspR = t.interface({
  broker_psp_code: t.string,

  description: t.string,

  enabled: t.boolean
});

// optional attributes
const BrokerPspO = t.partial({});

export const BrokerPsp = t.intersection([BrokerPspR, BrokerPspO], "BrokerPsp");

export type BrokerPsp = t.TypeOf<typeof BrokerPsp>;
